import * as React from "react";
import Typography from "@mui/joy/Typography";
import { Box, Divider } from "@mui/joy";

type InputSectionProps = {
  sectionTitle?: string;
  children: React.ReactNode;
};

export default function InputSection({ sectionTitle, children }: InputSectionProps) {
  return (
    <Box
      sx={{
        gridColumn: "1 / -1",
        width: "100%",
        mb: 2,
      }}
    >
      {sectionTitle && (
        <>
          <Typography
            level="title-md"
            sx={{
              mt: 3,
              mb: 2,
              fontWeight: 600,
            }}
          >
            {sectionTitle}
          </Typography>
          <Divider sx={{ mb: 3 }} />
        </>
      )}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "100%",
            sm: "50% 50%",
            lg: "repeat(auto-fit, 32%) 32%",
          },
          gap: 2,
          mb: 2,
        }}
      >
        {children}
      </Box>
      <Divider sx={{ mb: 4 }} />
    </Box>
  );
}
